import { toast } from 'react-toastify';
import { I18n } from '@utils/i18n';
import createApiAction from '../../api/createApiAction';
import * as c from './types';
import { toast as radixToast } from '@pulsarml/avalon-ui';

export const getCompanyUIConfig = () =>
  createApiAction({
    method: 'getCompanyUIConfig',
    requestAction: c.GET_COMPANY_UI_CONFIG_REQUEST,
    successAction: c.GET_COMPANY_UI_CONFIG_SUCCESS,
    errorHandler(dispatch, params) {
      const { response } = params;
      const error = response?.data?.error;
      if (error) {
        toast.error(error);
      }
      dispatch({
        type: c.GET_COMPANY_UI_CONFIG_ERROR,
        payload: error ?? 'unknown error'
      });
    },
    transformResponse: (data) => data
  });
export const updateCompanyUIConfig = (params) =>
  createApiAction({
    method: 'updateCompanyUIConfig',
    params,
    requestAction: c.UPDATE_COMPANY_UI_CONFIG_REQUEST,
    successAction: c.UPDATE_COMPANY_UI_CONFIG_SUCCESS,
    errorHandler(dispatch, { response }) {
      const error = response?.data?.error;
      if (error) {
        toast.error(error);
      }
      dispatch({
        type: c.UPDATE_COMPANY_UI_CONFIG_ERROR,
        payload: error ?? 'unknown error'
      });
    },
    transformResponse: () => params.config,
    afterSuccess: () =>
      radixToast({
        variant: 'success',
        title: I18n.t('changes_saved'),
        subtitle: I18n.t('changes_successfully_saved')
      })
  });

export const updateMachineMetricsConfig = (params) => {
  return {
    type: c.UPDATE_MACHINE_METRICS_CONFIG,
    payload: params
  };
};

export const toggleSidebarCollapsed = () => {
  return {
    type: c.TOGGLE_SIDEBAR_COLLAPSED
  };
};
